export default {
    newCars: '/nyir-bilar',
    oldCars: '/notadir-bilar'
}